export const BI_EVENTS: { [key: string]: string } = {
  onboarding_started: 'session_start',
  subs_purchase_show: 'subs_purchase_show',
  subs_purchase_started: 'subs_purchase_started',
  subs_purchase_completed: 'subs_purchase_completed',
  subs_purchase_failed: 'subs_purchase_failed',
};
